module.exports = __webpack_public_path__ + "static/media/step-2.489892ca.svg";